(() => {
  const schedules = document.querySelectorAll('[data-earthbabe-flight-schedule]');
  const pad = (value) => String(value).padStart(2, '0');

  const countdownParts = (target, now) => {
    const totalSeconds = Math.max(0, Math.floor((target.getTime() - now.getTime()) / 1000));
    return {
      days: Math.floor(totalSeconds / 86400),
      hours: Math.floor((totalSeconds % 86400) / 3600),
      minutes: Math.floor((totalSeconds % 3600) / 60),
      seconds: totalSeconds % 60,
    };
  };

  const activePhase = (dates, now) => {
    if (now < dates.firstOrderDeadline) {
      return {
        eyebrow: 'Order by',
        title: 'Order by October 9',
        subtitle: 'For the October 18 import flight',
        target: dates.firstOrderDeadline,
        detail: 'Flight departs October 18',
        delivery: 'Expected package delivery October 21–22',
        next: '<strong>Next window:</strong> Order by October 19 for the October 25 flight.',
        nextDelivery: 'Expected delivery October 28–29',
      };
    }

    if (now < dates.firstFlight) {
      return {
        eyebrow: 'Flight countdown',
        title: 'Flight departs October 18',
        subtitle: 'Ordering for this flight is closed',
        target: dates.firstFlight,
        detail: 'Packages arrive 3–4 days later',
        delivery: 'Expected package delivery October 21–22',
        next: '<strong>Still ordering?</strong> Order by October 19 for the October 25 flight.',
        nextDelivery: 'Expected delivery October 28–29',
      };
    }

    if (now < dates.secondOrderDeadline) {
      return {
        eyebrow: 'Order by',
        title: 'Order by October 19',
        subtitle: 'For the October 25 import flight',
        target: dates.secondOrderDeadline,
        detail: 'Flight departs October 25',
        delivery: 'Expected package delivery October 28–29',
        next: '<strong>October 18 flight:</strong> In transit.',
        nextDelivery: 'Expected delivery October 21–22',
      };
    }

    if (now < dates.secondFlight) {
      return {
        eyebrow: 'Flight countdown',
        title: 'Flight departs October 25',
        subtitle: 'Ordering for this flight is closed',
        target: dates.secondFlight,
        detail: 'Packages arrive 3–4 days later',
        delivery: 'Expected package delivery October 28–29',
        next: '<strong>October 18 flight:</strong> Delivery window in progress.',
        nextDelivery: 'Expected October 21–22',
      };
    }

    if (now < dates.scheduleExpiry) {
      return {
        eyebrow: 'Import in transit',
        title: 'October 25 flight departed',
        subtitle: 'The October ordering windows are closed',
        target: dates.scheduleExpiry,
        detail: 'Packages arrive 3–4 days after flight',
        delivery: 'Expected package delivery October 28–29',
        next: '<strong>Next import:</strong> New ordering dates will be posted here.',
        nextDelivery: '',
      };
    }

    return {
      eyebrow: 'Next import',
      title: 'New flight dates coming soon',
      subtitle: 'The October ordering windows are closed',
      target: null,
      detail: 'Next Day Air; California: USPS Express 1–2 days',
      delivery: '$60 flat rate with an insulated reptile box',
      next: '<strong>Next ordering window:</strong> Dates will be posted here.',
      nextDelivery: '',
    };
  };

  schedules.forEach((schedule) => {
    const dates = {
      firstOrderDeadline: new Date(schedule.dataset.firstOrderDeadline),
      firstFlight: new Date(schedule.dataset.firstFlight),
      secondOrderDeadline: new Date(schedule.dataset.secondOrderDeadline),
      secondFlight: new Date(schedule.dataset.secondFlight),
      scheduleExpiry: new Date(schedule.dataset.scheduleExpiry),
    };
    const countdown = schedule.querySelector('[data-flight-countdown]');

    const render = () => {
      const now = new Date();
      const phase = activePhase(dates, now);
      schedule.querySelector('[data-flight-eyebrow]').textContent = phase.eyebrow;
      schedule.querySelector('[data-flight-title]').textContent = phase.title;
      schedule.querySelector('[data-flight-subtitle]').textContent = phase.subtitle;
      schedule.querySelector('[data-flight-detail]').textContent = phase.detail;
      schedule.querySelector('[data-flight-delivery]').textContent = phase.delivery;
      schedule.querySelector('[data-next-flight]').innerHTML = phase.next;
      schedule.querySelector('[data-next-delivery]').textContent = phase.nextDelivery;

      if (!phase.target) {
        countdown.hidden = true;
        return;
      }

      countdown.hidden = false;
      const parts = countdownParts(phase.target, now);
      schedule.querySelector('[data-countdown-days]').textContent = pad(parts.days);
      schedule.querySelector('[data-countdown-hours]').textContent = pad(parts.hours);
      schedule.querySelector('[data-countdown-minutes]').textContent = pad(parts.minutes);
      schedule.querySelector('[data-countdown-seconds]').textContent = pad(parts.seconds);
    };

    render();
    window.setInterval(render, 1000);
  });
})();
